import { Injectable } from '@angular/core';
import { Idle } from '@ng-idle/core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class IdleTimeService {

  constructor(private http: HttpClient) {
   }

   getIdleProperties(){
    return this.http.get<any>(environment.apiUrl+'/api/security/getIdleTimeProperties')
  }
}
